export default __webpack_public_path__ + "static/media/news84.960a17b5.jpg";